import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import PaymentFactory from "../../Entity/Factories/PaymentFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { PaymentInterface } from "../../Entity/Entities/Payment/PaymentInterface";
import Translator from "../../Translation/Translator";

export default function* paymentCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_PAYMENT_CREATE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_PAYMENT_CREATE_REQUEST
    });

    let res = null;

    if (!!action.payload?.payment.additionalCharge && Object.keys(action?.payload?.payment?.additionalCharge || {}).length > 0) {
      res = yield call(Http.post, `payment/create-and-link`, {
        payment: action.payload?.payment,
        additionalCharge: action.payload?.payment.additionalCharge
      });

    } else {
      res = yield call(Http.post, `payment`, action.payload?.payment)
    }

    const payment: PaymentInterface = PaymentFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_PAYMENT_CREATE_SUCCESS
    });

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-payment-created-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, payment);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_PAYMENT_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPaymentCreate() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_CREATE_START, paymentCreate);
}
